import React from 'react'

const UnresolvedProbelem = () => {
  return (
    <div>UnresolvedProbelm</div>
  )
}

export default UnresolvedProbelem